import CommunityMarker from './CommunityMarker'
export default CommunityMarker
